<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>Members</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0" >
        <table class="table table-sm align-items-center mb-0" >
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 " >
                Line Display</th>
                <!-- <button @click="sort_line_clicked()">Line Display / UID</button></th> -->
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >ยอดเติม</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >ส่วนแบ่ง</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Status</th>
              <!-- ><button @click="sort_status_clicked()">Status</button></th> -->
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.username">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{user.line_display}}</h6>
                    <!-- <p class="text-xs text-secondary mb-0">{{user.username.slice(0,15) + " .."}}</p> -->
                  </div>
                </div>
              </td>


              <td class="align-middle text-center text-sm">
                <span class="text-secondary text-xs font-weight-bold">0.00</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">0.00</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">-</span>
              </td>
              <!-- <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{new Date(user.expire_date).toLocaleDateString('th-TH')  }} ({{user.balance_days}})</span>
              </td> -->

            </tr> 



          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
const qs = require('querystring')
var host_api=window.localStorage.getItem('$host_api');

export default {
  name: "referrers-table",
  props:{
    uid:String
  },
  data() {
    return {
      users : [],
      username : "admin_jay",
      sort_type : 0
    }
  },
  methods :{ 
    reload_users(){           
      host_api=window.localStorage.getItem('$host_api');
      const config = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
      const requestBody = {
      }

      axios.post(host_api+"/admin/users/all", qs.stringify(requestBody), config,
        ).then(response => {
            if (response.data.status == "success") {
              // this.users = response.data.users
              if (this.uid != null && this.uid != '' && this.uid != undefined) {
                console.log('yes')
                response.data.users.forEach(user => {
                  if (user.ref_username == this.uid) {
                    user.balance_days = this.check_usage_days(user.expire_date) 
                    if (user.type == 0 )
                      user.type_str = "Member"
                    else if (user.type == 1)
                      user.type_str = "Influencer"
                    else 
                      user.type_str = "Unknown"
                    
                    if (user.line_display == '' || user.line_display == null || user.line_display == undefined) {
                      user.line_display = "[No Line Display]"
                      if (user.line_display.length > 15)
                        user.line_display = user.line_display.slice(0,15) + '..'
                    }

                    response.data.users.forEach(ref => {
                      if (user.ref_username == ref.username)
                        user.ref_str = ref.line_display
                    });
                    this.users.push(user)
                  }
                });
              } else { 
                console.log("no")
                response.data.users.forEach(user => {
                  user.balance_days = this.check_usage_days(user.expire_date) 
                  if (user.type == 0 )
                    user.type_str = "Member"
                  else if (user.type == 1)
                    user.type_str = "Influencer"
                  else 
                    user.type_str = "Unknown"
                  
                  if (user.line_display == '' || user.line_display == null || user.line_display == undefined) {
                    user.line_display = "[No Line Display]"
                  } else if  (user.line_display.length > 15) {
                    user.line_display = user.line_display.slice(0,15) + '..'
                  }

                  response.data.users.forEach(ref => {
                    if (user.ref_username == ref.username)
                      user.ref_str = ref.line_display
                  });
                  this.users.push(user)
                });
              }
            }
            else {
                console.log("False")
            }
        })
    }, 
    check_usage_days (expire_date) {
      var today =new Date()
      var lastday = new Date(expire_date)
      var difference = Math.floor((lastday - today) / (1000*60*60*24))
      difference = difference + 1
      if (difference < 0 )
        return 'expired'
      return difference + ' วัน'
    },

    sort_line_clicked (){
      this.sort_type = 0
    },
    sort_status_clicked (){
      this.sort_type = 2
    },

  },
  created() {
    console.log(this.uid)
    // this.users = this.$route.params.members
    this.users = this.$store.state.members
    this.users.forEach(user => {
      if(user.line_display == null || user.line_display == '' || user.line_display == undefined)
        user.line_display = '[No Display]'
      // console.log(user.line_display.slice(15))
      // var u = user.line_display
      // console.log(u)
      else if (user.line_display.length > 15)
        user.line_display = user.line_display.slice(0,15);
    });
    // console.log(this.users)
    // this.reload_users();

  }, 
  computed: {
    // orderedUsers : function() {
    // if (this.sort_type == 0 )
    //   return this.users.sort((a, b) => a.line_display > b.line_display ? 1 : -1);
    // else if (this.sort_type == 1 )
    //   return this.users.sort((a, b) => a.ref_str > b.ref_str ? 1 : -1);
    // else if (this.sort_type == 2 )
    //   return this.users.sort((a, b) => a.expire_date > b.expire_date ? 1 : -1);
    // else if (this.sort_type == 3 )
    //   return this.users.sort((a, b) => a.type > b.type ? 1 : -1);

    // }
  }
};

</script>
